import { SET_SUPPLIERS, SET_SUPPLIERS_LOADING, SET_SUPPLIERS_ERROR } from "../../actions/supplierAction";

var initialState = {
  datas: [],
  loading: false,
  error: null,
};

const supplierReducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case SET_SUPPLIERS:
      return {
        ...state,
        datas: action.data,
      };

    case SET_SUPPLIERS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case SET_SUPPLIERS_LOADING:
      return {
        ...state,
        loading: action.status,
      };
    default:
      return state;
  }
};

export default supplierReducer;
